// extracted by mini-css-extract-plugin
export var celebrity = "BrandLogosFooter-module--celebrity--2e6ac";
export var logo = "BrandLogosFooter-module--logo--702ed";
export var logoBig = "BrandLogosFooter-module--logo-big--72fbb";
export var logoBigContainer = "BrandLogosFooter-module--logo-big-container--46c69";
export var logoBigWithRow = "BrandLogosFooter-module--logo-big-with-row--507da";
export var logosRow = "BrandLogosFooter-module--logos-row--3757c";
export var royal = "BrandLogosFooter-module--royal--3aa2f";
export var wrapper = "BrandLogosFooter-module--wrapper--246bd";